import { useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'upcoming_appointment',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({ type: 'reFetch' })
    if (typeof props.closePopover === 'function') props.closePopover()
  }
}
